<template>
  <div v-if="!ready" class="app-status-lock"></div>
  <AppOffline v-else-if="offline" :mensagem="mensagem" />
  <template v-else>
    <banner-top />
    <NavigationBar />
    <router-view :key="$route.fullPath" />
    <home-footer />
  </template>
</template>

<script>
import { onValue, ref } from "firebase/database";
import { db } from "@/services/firebase";
import NavigationBar from "@/components/NavigationBar.vue";
import BannerTop from "./components/BannerTop.vue";
import HomeFooter from "./components/MainFooter.vue";
import AppOffline from "./components/AppOffline.vue";

export default {
  name: "App",
  components: {
    NavigationBar,
    BannerTop,
    HomeFooter,
    AppOffline,
  },
  data() {
    return {
      ready: false,
      offline: false,
      mensagem:
        "Aplicação temporariamente indisponível. Tente novamente mais tarde.",
    };
  },
  created() {
    onValue(
      ref(db, "aplicacao"),
      (snapshot) => {
        const data = snapshot.val();
        if (!data) {
          this.offline = false;
          this.ready = true;
          return;
        }
        this.mensagem =
          data.mensagem ||
          "Aplicação temporariamente indisponível. Tente novamente mais tarde.";
        this.offline = data.site === false;
        this.ready = true;
      },
      () => {
        this.offline = false;
        this.ready = true;
      }
    );
  },
};
</script>

<style>
@import "@/assets/main.css";

.app-status-lock {
  min-height: 100vh;
  width: 100%;
  background: #fff;
}
</style>
